import React from "react";
import DummyDashboard from "./DummyDashboard";

const LandingPage = () => {
  return <DummyDashboard />;
};

export default LandingPage;
